; (function ($, _) {
    var common = require('../common');

    var dialogTpl =
        '<div class="diag_box base_pop" style="display:none">' +
        '   <div class="diag_head base_pop_t">' +
        '       <h3 class="diag_title"></h3>' +
        '       <a href="javascript:;" class="diag_close pop_close" title="关闭">关闭</a>' +
        '    </div>' +
        '    <div class="diag_body base_pop_m">' +
        '       <div class="pop_feedback">' +
        '           <span class="diag_icon"></span>' +
        '           <span class="diag_msg"></span>' +
        '       </div>' +
        '       <div class="diag_foot pop_btn">' +
        '           <a href="javascript:;" class="diag_ensure btn_pop_2" title=""></a>' +
        '           <a href="javascript:;" class="diag_cancel btn_pop_2" title=""></a>' +
        '       </div>' +
        '   </div>' +
        '</div>';

    var opts = {
        title: '提示',
        msg: '',
        ensureText: '确定',
        cancelText: '取消',
        ensureBtn: '.diag_ensure',
        cancelBtn: '.diag_cancel',
        closeBtn: '.diag_close',
        icon: 'ico_p_ok',
        ensureHandler: $.noop,
        cancelHandler: $.noop,
        ensureBtnEnable: true,
        cancelBtnEnable: false,
        template: dialogTpl
    };

    var $ensureBtn = null;
    var $cancelBtn = null;
    var $closeBtn = null;

    var Dialog = {
        init: function (options) {
            this.initUI(options);
            this.eventBinding();
        },

        initUI: function (options) {
            opts = _.extend(opts, options);
            $(opts.template).appendTo($('body'));
            $ensureBtn = $(opts.ensureBtn);
            $cancelBtn = $(opts.cancelBtn);
            $closeBtn = $(opts.closeBtn);
        },

        eventBinding: function () {
            $closeBtn.on('click', function () {
                Dialog.hide();
            });

            $ensureBtn.on('click', function () {
                Dialog.hide();
                typeof opts.ensureHandler == 'function' && opts.ensureHandler();
            });

            $cancelBtn.on('click', function () {
                Dialog.hide();
                typeof opts.cancelHandler == 'function' && opts.cancelHandler();
            });
        },

        show: function (msg) {
            $('.diag_title').html(opts.title);
            $('.diag_icon').attr('class', 'diag_icon ' + opts.icon);
            $('.diag_msg').html(msg);
            if (opts.ensureBtnEnable) {
                $ensureBtn.attr('title', opts.ensureText)
                    .text(opts.ensureText)
                    .show();
            } else {
                $ensureBtn.hide();
            }
            if (opts.cancelBtnEnable) {
                $cancelBtn.attr('title', opts.cancelText)
                    .text(opts.cancelText)
                    .show();
            } else {
                $cancelBtn.hide();
            }
            $('.diag_box').show();
        },

        hide: function () {
            $('.base_pop').hide();
        },

        alert: function (msg) {
            opts = _.extend(opts, {
                ensureBtnEnable: true,
                cancelBtnEnable: false,
                cancelHandler: $.noop
            });
            this.show(msg);
        },

        confirm: function (msg, options) {
            opts = _.extend(opts, options, {
                ensureBtnEnable: true,
                cancelBtnEnable: true
            });
            this.show();
        },

        prompt: function (msg, options) {
            opts = _.extend(opts, options, {
                ensureBtnEnable: true,
                cancelBtnEnable: true
            });
            this.show();
        }
    };

    // 页面入口
    $(function () {
        Dialog.init();
    });

    if (typeof exports === 'object') {
        module.exports = Dialog;
    }
})(jQuery, _);


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/ui/dialog.js
// module id = 23
// module chunks = 1 10